import {domains} from '../constants/Utils';
import {sparePartsWebsocketCommands} from '../constants/sparePartsWebsocketCommands';
import {techDocWebsocketCommands} from '../constants/techDocWebsocketCommands';
import {claimsWebsocketCommands} from '../constants/claimsWebsocketCommands';
import { adminWebsocketCommands } from '../constants/adminWebsocketCommands';

export const FILES_UPLOAD_PENDING = 'FILES_UPLOAD_PENDING';
export const FILES_DOWNLOAD_PENDING = 'FILES_DOWNLOAD_PENDING';
export const FILE_UPLOAD_STATUS = 'FILE_UPLOAD_STATUS';

export const downloadFile = (domain, {uuid, name}, problemId) => dispatch => {
    switch (domain) {
        case domains.SPARE_PARTS: {
            return dispatch({
                type: FILES_DOWNLOAD_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_RECURRENT_PROBLEMS_FILE_DOWNLOAD,
                payload: {attachment: {uuid, name, problemId}}
            });
        }
        case domains.TECHNICAL_DOCUMENTATION: {
            return dispatch({
                type: FILES_DOWNLOAD_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_RECURRENT_PROBLEMS_FILE_DOWNLOAD,
                payload: {attachment: {uuid, name, problemId}}
            });
        }
        case domains.CLAIMS: {
            return dispatch({
                type: FILES_DOWNLOAD_PENDING,
                claimsWebsocket: true,
                command: claimsWebsocketCommands.CLAIMS_RECURRENT_PROBLEMS_FILE_DOWNLOAD,
                payload: {attachment: {uuid, name, problemId}}
            });
        }
        case domains.ADMINISTRATION: {
            return dispatch({
                type: FILES_DOWNLOAD_PENDING,
                adminWebsocket: true,
                command: adminWebsocketCommands.ADMIN_HELP_FILE_DOWNLOAD,
                payload: {attachment: {uuid, name}}
            });
        }
    }
};

export const uploadFile = (domain, uuid, problemId, contentType, localFileUrl) => dispatch => {
    switch (domain) {
        case domains.SPARE_PARTS: {
            dispatch({type: FILE_UPLOAD_STATUS, payload: {uuid}});
            return dispatch({
                type: FILES_UPLOAD_PENDING,
                sparePartsWebsocket: true,
                command: sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_RECURRENT_PROBLEMS_FILE_UPLOAD,
                payload: {attachment: {uuid, problemId, contentType, localFileUrl}}
            });
        }
        case domains.TECHNICAL_DOCUMENTATION: {
            dispatch({type: FILE_UPLOAD_STATUS, payload: {uuid}});
            return dispatch({
                type: FILES_UPLOAD_PENDING,
                techDocWebsocket: true,
                command: techDocWebsocketCommands.TECH_DOC_RECURRENT_PROBLEMS_FILE_UPLOAD,
                payload: {attachment: {uuid, problemId, contentType, localFileUrl}}
            });
        }
        case domains.CLAIMS: {
            dispatch({type: FILE_UPLOAD_STATUS, payload: {uuid}});
            return dispatch({
                type: FILES_UPLOAD_PENDING,
                claimsWebsocket: true,
                command: claimsWebsocketCommands.CLAIMS_RECURRENT_PROBLEMS_FILE_UPLOAD,
                payload: {attachment: {uuid, problemId, contentType, localFileUrl}}
            });
        }
    }
};

